import React, { useState } from 'react'
import Date from '../../date/relative'
import JOB_STATES from '../../../constants/job-states'
import JobModal from '../job-modal'
import { describeSchedule, getNextRun, formatJobTime } from '../job-schedule'

const JobListItem = ({
    job = {},
}) => {
    const {
        name,
        state,
        schedule,
        lastRunDate,
    } = job

    const [ isDetailsVisible, setDetailsVisible] = useState(false)

    const renderNextRun = () => {
        if (state === JOB_STATES.STARTED) {
            return 'Running'
        }
        const { isManual, isDue, nextRun } = getNextRun(job)
        if (isManual) {
            return 'DISABLED'
        }
        if (isDue) {
            return 'Due now (within ~2 min)'
        }
        return nextRun ? (<span title={formatJobTime(nextRun)}><Date value={nextRun} /></span>) : ''
    }

    const renderDetails = () => {
        return isDetailsVisible ? (<JobModal job={job} onHide={() => setDetailsVisible(false)} />) : null
    }

    return (
        <React.Fragment>
            <tr
                style={{
                    cursor: 'pointer'
                }}
                onClick={() => setDetailsVisible(true)}
            >
                <td>{name}</td>
                <td>{state}</td>
                <td><Date value={lastRunDate} invalidLabel='Never' /></td>
                <td title={schedule || ''}>{describeSchedule(job)}</td>
                <td>{renderNextRun()}</td>
            </tr>
            {renderDetails()}
        </React.Fragment>
    )
}

export default JobListItem
